import hasAlreadyFiled from './hasAlreadyFiled';
import hasUnpaidCreditors from './hasUnpaidCreditors';
import eligibilitySummary from './eligibilitySummary';
import veteranFullName from './veteranFullName';
import veteranIdentifiers from './veteranIdentifiers';
import beneficiaryIsVeteran from './beneficiaryIsVeteran';
import beneficiaryFullName from './beneficiaryFullName';
import beneficiaryDateOfDeath from './beneficiaryDateOfDeath';
import claimantNameAndDob from './claimantNameAndDob';
import claimantSSN from './claimantSSN';
import claimantMailingAddress from './claimantMailingAddress';
import claimantPhoneAndEmail from './claimantPhoneAndEmail';
import claimantRelationshipToDeceased from './claimantRelationshipToDeceased';
import waiverOfSubstitution from './waiverOfSubstitution';
import relativesOverview from './relativesOverview';
import { relativesPages } from './relativesDetails';
import expensesClaim from './expensesClaim';
import { expensesPages } from './expensesList';
import otherDebts from './otherDebts';
import { otherDebtsPages } from './otherDebtsList';
import remarks from './remarks';
import supportingDocuments from './supportingDocuments';

export {
  hasAlreadyFiled,
  hasUnpaidCreditors,
  eligibilitySummary,
  veteranFullName,
  veteranIdentifiers,
  beneficiaryIsVeteran,
  beneficiaryFullName,
  beneficiaryDateOfDeath,
  claimantNameAndDob,
  claimantSSN,
  claimantMailingAddress,
  claimantPhoneAndEmail,
  claimantRelationshipToDeceased,
  waiverOfSubstitution,
  relativesOverview,
  relativesPages,
  expensesClaim,
  expensesPages,
  otherDebts,
  otherDebtsPages,
  remarks,
  supportingDocuments,
};
